import { USER_GROUP_RYD } from '@/constants/constants';

// Matches rp-users `assertCanSwitchUserGroup` exactly (rule R4, RYD-SEC-2026-001):
// the user_group_switcher role, nothing else. The number of configured entities
// no longer matters, and the legacy `userGroupSwitcher` spelling is not accepted
// by the backend.
export function canSwitchCompanyEntity({ roles = [] } = {}) {
  const normalizedRoles = Array.isArray(roles) ? roles : [];
  return normalizedRoles.includes('user_group_switcher');
}

// Mirrors rp-users `assertCanSwitchUserGroup` rules R4b and R4c: ryd is excluded from
// switching. A user whose current group is ryd, or who has ryd among the configured
// company entities, cannot switch. The dialog shows a warning instead of switch options.
export function isCompanySwitchBlocked(userGroup, availableUserGroups = []) {
  return (
    userGroup === USER_GROUP_RYD ||
    (Array.isArray(availableUserGroups) &&
      availableUserGroups.some((entity) => entity?.userGroup === USER_GROUP_RYD))
  );
}

export function getUserAddDataFromLocalStorage() {
  try {
    const userAddDataAsStr = localStorage.getItem('userAddData');
    const userAddData = userAddDataAsStr ? JSON.parse(userAddDataAsStr) : null;
    const uid = userAddData ? userAddData.uid : null;
    const userGroup = userAddData ? userAddData.userGroup : null;
    const isUserGroupRyd =
      userAddData && userAddData.userGroup ? userAddData.userGroup === USER_GROUP_RYD : false;
    const partnerSettings = userAddData ? userAddData.partnerSettings : null;
    const partnerTypes = userAddData ? userAddData.partnerTypes : [];
    const currentPartnerType = userAddData ? userAddData.currentPartnerType : null;
    const language = userAddData ? userAddData.language : null;
    const timezone = userAddData ? userAddData.timezone : null;
    const roles = userAddData ? userAddData.roles : null;
    const email = userAddData ? userAddData.email : null;
    const firstName = userAddData ? userAddData.firstName : null;
    const lastName = userAddData ? userAddData.lastName : null;

    // User group switching fields
    const organization = userAddData ? userAddData.organization : null;
    const availableUserGroups = userAddData ? userAddData.availableUserGroups : null;
    const currentUserGroupId = userAddData ? userAddData.currentUserGroupId : null;

    // Computed: can user switch user groups?
    const canSwitchUserGroups = Boolean(
      userAddData && canSwitchCompanyEntity({ roles: roles || [] }),
    );

    return {
      userAddData,
      uid,
      isUserGroupRyd,
      userGroup,
      partnerSettings,
      partnerTypes,
      currentPartnerType,
      language,
      timezone,
      roles,
      email,
      firstName,
      lastName,
      organization,
      availableUserGroups,
      currentUserGroupId,
      canSwitchUserGroups,
    };
  } catch (e) {
    console.error('Error parsing user data from localStorage', e);
    return {
      userAddData: null,
      uid: null,
      isUserGroupRyd: false,
      userGroup: null,
      partnerSettings: null,
      partnerTypes: [],
      currentPartnerType: null,
      language: null,
      timezone: null,
      roles: null,
      email: null,
      firstName: null,
      lastName: null,
      organization: null,
      availableUserGroups: null,
      currentUserGroupId: null,
      canSwitchUserGroups: false,
    };
  }
}
